import { useCallback, useContext, useEffect, useMemo, useState } from 'react';
import css from './AccountActivation.module.scss';
import SingleButton from '../../../../widgets/form/form-control-buttons/SingleButton/SingleButton';
import T from '../../../../common/components/T';
import ActivateAccountModal from '../../../../widgets/activateAccountModal/ActivateAccountModal';
import GridComponent from '../../../../widgets/grid/GridComponent/GridComponent';
import { packageThead, thead, transformData } from './helpers';
import { LangContext } from '../../../../common/decorators/Language';
import UserContext, { StoreContext, UserProfileContext } from '../../../../common/utils/getContext';
import { dataSender } from '../../../../common/utils/router';
import { API_SERVER_URL, getCartData, getNumberAndCurrencyFromString } from '../../../../common/utils/utils';
import classNames from 'classnames';
import { zendoStorage } from '../../../../hybrid/wrappers';

const AccountActivation = ({ setActiveStep, partner, userData, initValue, isOfficeRegister }) => {
    const { translation } = useContext(LangContext);
    const { cartData, setCartData } = useContext(StoreContext);
    const { userToken, lang } = useContext(UserContext);
    const { profileData } = useContext(UserProfileContext);
    const [showModal, setShowModal] = useState(false);
    useEffect(() => {
        (async () => {
            if (partner?.id) {
                const cartId = null;
                const cartDataRes = await getCartData(
                    cartId,
                    userToken,
                    lang,
                    false,
                    isOfficeRegister ? initValue?.country_id?.currency : profileData?.currency?.code,
                    partner.id
                );
                if (cartDataRes?.data) {
                    setCartData(cartDataRes?.data);
                }
            }
        })();
    }, [initValue?.country_id?.currency, isOfficeRegister, profileData?.currency?.code, partner, userToken, lang]);

    const products = useMemo(() => {
        return transformData(translation)(cartData?.items);
    }, [cartData]);

    const [type, setType] = useState(null);

    const confirmFunction = useCallback(
        (data) => {
            setType(data?.type);
            dataSender(
                `${API_SERVER_URL}/api/v1/shop/carts/${cartData.id}/clear?_method=DELETE`,
                'DELETE',
                null,
                (res) => {
                    setCartData(res?.data?.data);
                    zendoStorage.set('cart_id', cartData.id);
                    Promise.all(
                        data.items.map((product) => {
                            return dataSender(
                                `${API_SERVER_URL}/api/v1/shop/carts/${cartData.id}/add-product`,
                                'POST',
                                {
                                    product_id: product.id,
                                    quantity: product.quantity || 1
                                },
                                (res) => {
                                    setCartData(res?.data?.data);
                                },
                                () => {},
                                userToken,
                                lang,
                                isOfficeRegister ? initValue?.country_id?.currency : profileData?.currency?.code
                            );
                        })
                    );
                },
                () => {},
                userToken,
                lang,
                isOfficeRegister ? initValue?.country_id?.currency : profileData?.currency?.code
            );
        },
        [userToken, lang, cartData, profileData]
    );

    const quantityHandler = useCallback(
        (row, type) => {
            if (type === 'minus') {
                if (row.quantity <= 1) return;
                dataSender(
                    `${API_SERVER_URL}/api/v1/shop/carts/${cartData.id}/set-product`,
                    'POST',
                    {
                        product_id: row?.id,
                        quantity: row?.quantity - 1
                    },
                    (res) => {
                        setCartData(res?.data?.data);
                    },
                    () => {},
                    userToken,
                    lang,
                    isOfficeRegister ? initValue?.country_id?.currency : profileData?.currency?.code
                );
            } else if (type === 'plus') {
                dataSender(
                    `${API_SERVER_URL}/api/v1/shop/carts/${cartData.id}/set-product`,
                    'POST',
                    {
                        product_id: row?.id,
                        quantity: row?.quantity + 1
                    },
                    (res) => {
                        setCartData(res?.data?.data);
                    },
                    () => {},
                    userToken,
                    lang,
                    isOfficeRegister ? initValue?.country_id?.currency : profileData?.currency?.code
                );
            }
        },
        [userToken, lang, cartData, profileData]
    );

    const buttonDisabled = useMemo(() => {
        if (!cartData?.items?.length) return true;
        return false;
    }, [cartData]);

    return (
        <div>
            <SingleButton
                type='cancel'
                icon='bag'
                buttonText={<T textName='choose-product' defaultStr='Выбрать товар' page='/store/register' />}
                customButton={{
                    sprite: {
                        className: css.icon
                    },
                    spriteWrapper: {
                        className: css.iconWrapper
                    },
                    singleButton: {
                        className: css.button
                    }
                }}
                onTouchEndEvent={false}
                clickFunc={() => setShowModal(true)}
            />
            <div className={css.squares}>
                <div className={classNames(css.greyBlock, { [css.greenBlock]: !buttonDisabled })}>
                    <p className={css.greyBlockTitle}>
                        <T textName='selected-amount' defaultStr='Выбрано на сумму' page='/store/register' />
                    </p>
                    <div className={css.greyBlockValues}>
                        <p className={css.greyBlockValue}>
                            <p>
                                <span className={css.greyBlockValue_int}>
                                    {cartData?.total_price_for_currency
                                        ? Number(cartData?.total_price_for_currency).toLocaleString()
                                        : '0'}
                                </span>{' '}
                                <span className={css.greyBlockValue_currency}>
                                    {isOfficeRegister
                                        ? getNumberAndCurrencyFromString(cartData?.total_price_for_currency_formatted)?.currency
                                        : profileData?.currency?.symbol}
                                </span>
                            </p>
                        </p>
                        <p className={css.greyBlockSeparator}>/</p>
                        <p className={css.greyBlockValue}>
                            <p>
                                <span className={css.greyBlockValue_int}>
                                    {cartData?.total_main_price ? Number(cartData?.total_main_price).toLocaleString() : '0'}
                                </span>{' '}
                                <span className={css.greyBlockValue_currency}>{cartData?.currency?.code}</span>
                            </p>
                        </p>
                    </div>
                </div>
                {/*<div className={css.greyBlock}>*/}
                {/*    <p className={css.greyBlockTitle}>*/}
                {/*        <T textName='referral-bonus' defaultStr='Реферальный бонус' page='/store/register' />*/}
                {/*    </p>*/}
                {/*    <p className={css.greyBlockValue}>*/}
                {/*        <p>*/}
                {/*            <span className={css.greyBlockValue_int}>{cartData?.agent_fee || '0'}</span>{' '}*/}
                {/*            <span className={css.greyBlockValue_currency}>{cartData?.currency?.code}</span>*/}
                {/*        </p>*/}
                {/*    </p>*/}
                {/*</div>*/}
            </div>
            {products?.data?.length ? (
                <GridComponent
                    viewThead={type === 'set' ? packageThead : thead}
                    viewData={products}
                    convertData={transformData(translation)}
                    gridStyles={{
                        price: {
                            td: {
                                div: {
                                    className: css.priceTd
                                }
                            }
                        },
                        currency_price: {
                            td: {
                                div: {
                                    className: css.priceTd
                                }
                            }
                        }
                    }}
                    handlers={{
                        quantity: {
                            minus: {
                                onClick: (row) => {
                                    quantityHandler(row, 'minus');
                                }
                            },
                            plus: {
                                onClick: (row) => {
                                    quantityHandler(row, 'plus');
                                }
                            }
                        }
                    }}
                />
            ) : null}

            <SingleButton
                type='ok'
                buttonText={<T textName='further' defaultStr='Далее' page='/store/register' />}
                customButton={{
                    singleButton: {
                        className: css.nextButton
                    }
                }}
                clickFunc={() => setActiveStep((s) => s + 1)}
                disabled={buttonDisabled}
            />
            {showModal ? (
                <ActivateAccountModal
                    value={{ type: type, items: cartData?.items?.map((it) => ({ ...it?.product, quantity: it.quantity })) }}
                    confirmFunction={confirmFunction}
                    closeHandler={() => setShowModal(false)}
                    country={userData?.country_id}
                    isOfficeRegister={isOfficeRegister}
                    initValue={initValue}
                />
            ) : null}
        </div>
    );
};

export default AccountActivation;
